import { analyticsGenerated } from "./generated/analytics";

export type RecurringMeetingSeries = {
  id: string;
  recurring_root_event_idr: string;
  leader: number;
  meeting_name: string;
  normalized_meeting_name: string;
  frequency: string | null;
  day_of_week: string;
  time: string;
  duration_minutes: number;
  attendees: string[];
  meeting_owner: string;
  meeting_organizer: string;
  calendar_id: string;
  series_start_date: string;
  series_end_date: string | null;
  rrule: string | null;
  dtstart: string;
  grouping_parent_id: string | null;
  grouping_child_ids: string[];
  hierarchy?: string[];
};

export type RecurringMeetingSeriesListResponse = RecurringMeetingSeries[];

export type AppAnalyticsEventsRecurringSeriesListApiArg = {
  active?: boolean;
  leader?: number;
  search?: string;
};

export type HideRecurringMeetingGroupRequest = {
  leader: number;
  normalized_meeting_name: string;
  sample_recurring_root_event_idr: string;
};

export const analytics = analyticsGenerated.enhanceEndpoints({}).injectEndpoints({
  endpoints: (build) => ({
    appAnalyticsEventsRecurringSeriesList: build.query<
      RecurringMeetingSeriesListResponse,
      AppAnalyticsEventsRecurringSeriesListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1_15/app-analytics/events/recurring-series/`,
        params: {
          active: queryArg.active,
          leader: queryArg.leader,
          search: queryArg.search,
        },
      }),
      providesTags: ["api"],
    }),
    appAnalyticsEventsHideRecurringSeries: build.mutation<
      HideRecurringMeetingGroupRequest,
      HideRecurringMeetingGroupRequest
    >({
      query: (body) => ({
        url: `/api/v1_15/app-analytics/events/recurring-series/hide/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["api"],
    }),
  }),
});
